<template>
  <div>
    <!-- <Preloader v-if="isLoading" /> -->
    <LeftSidebar v-if="shouldShowSidebar && !isNotFound" />
    <!-- <div class="container-fluid"> -->
    <div class="main-content d-flex flex-column" :class="{ 'p-0': shouldShowPaddingZero || isNotFound }">
      <TopHeader v-if="shouldShowHeader && !isNotFound" />
      <router-view />
      <div class="flex-grow-1" v-if="shouldShowDiv && !isNotFound"></div>
      <MainFooter v-if="shouldShowFooter && !isNotFound" />
    </div>
    <!-- </div> -->
    <CreateTaskModal />
    <!--
    <AddNewLabelModal />
    <AddNewCardModal />
    <AddNewFileModal />
    <AddNewOrderModal />
    <AddNewCategorieModal />
    <AddNewContactModal />
    <AddNewCustomerModal />
    <AddNewLeadModal />
    <AddNewDealsModal />
    <AddNewUserModal />
    <AddNewInstructorsModal />
    <SettingsSidebar /> -->
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watchEffect, computed } from "vue";
import { useRoute } from "vue-router";
import stateStore from "./utils/store";

import Preloader from "./components/Layouts/Preloader.vue";
import LeftSidebar from "./components/Layouts/LeftSidebar.vue";
import TopHeader from "./components/Layouts/TopHeader/index.vue";
import MainFooter from "./components/Layouts/MainFooter.vue";
import CreateTaskModal from "./components/Layouts/CreateTaskModal.vue";
import AddNewLabelModal from "./components/Layouts/AddNewLabelModal.vue";
import AddNewCardModal from "./components/Layouts/AddNewCardModal.vue";
import AddNewFileModal from "./components/Layouts/AddNewFileModal.vue";
import AddNewOrderModal from "./components/Layouts/AddNewOrderModal.vue";
import AddNewCategorieModal from "./components/Layouts/AddNewCategorieModal.vue";
import AddNewContactModal from "./components/Layouts/AddNewContactModal.vue";
import AddNewCustomerModal from "./components/Layouts/AddNewCustomerModal.vue";
import AddNewLeadModal from "./components/Layouts/AddNewLeadModal.vue";
import AddNewDealsModal from "./components/Layouts/AddNewDealsModal.vue";
import AddNewUserModal from "./components/Layouts/AddNewUserModal.vue";
import AddNewInstructorsModal from "./components/Layouts/AddNewInstructorsModal.vue";
import SettingsSidebar from "./components/Layouts/SettingsSidebar/index.vue";

export default defineComponent({
  name: "App",
  components: {
    Preloader,
    LeftSidebar,
    TopHeader,
    MainFooter,
    CreateTaskModal,
    AddNewLabelModal,
    AddNewCardModal,
    AddNewFileModal,
    AddNewOrderModal,
    AddNewCategorieModal,
    AddNewContactModal,
    AddNewCustomerModal,
    AddNewLeadModal,
    AddNewDealsModal,
    AddNewUserModal,
    AddNewInstructorsModal,
    SettingsSidebar,
  },
  setup() {
    const isLoading = ref(true);
    const route = useRoute();

    const hiddenRoutes = [
      "/",
      "/service",
      "/services/:id",
      "/serviceProduct/:id",
      "/product/:id",
      "/features",
      "/our-team",
      "/terms-and-conditions",
      "/privacy-policy",
      "/faq",
      "/contact",
      "/category/:id",
      "/category/category/:id",
      "/cart",
      "/checkout",
      "/payment",
      "/order-success",
      "/orders",
      "/authentication/otp",
      "/authentication/login",
      "/authentication/logout",
      "/authentication/register",
      "/authentication/reset-password",
      "/authentication/forget-password",
      "/authentication/lock-screen",
      "/authentication/confirm-mail",
    ];

  
    const doesPathMatch = (path: string, hiddenRoutes: string[]): boolean => {
      return hiddenRoutes.some((hiddenPath: string) => {
        const regex = new RegExp(`^${hiddenPath.replace(/:[^/]+/g, "[^/]+")}$`);
        return regex.test(path);
      });
    };

    const shouldShowSidebar = computed(() => !doesPathMatch(route.path, hiddenRoutes));
    const shouldShowPaddingZero = computed(() => doesPathMatch(route.path, hiddenRoutes));
    const shouldShowHeader = computed(() => !doesPathMatch(route.path, hiddenRoutes));
    const shouldShowDiv = computed(() => !doesPathMatch(route.path, hiddenRoutes));
    const shouldShowFooter = computed(() => !doesPathMatch(route.path, hiddenRoutes));

    const isNotFound = computed(() =>
      route.matched.some((record) => record.path === "/:pathMatch(.*)*")
    );

    onMounted(() => {
      setTimeout(() => {
        isLoading.value = false;
      }, 1000);

      watchEffect(() => {
        if (stateStore.open) {
          document.body.classList.remove("sidebar-show");
          document.body.classList.add("sidebar-hide");
        } else {
          document.body.classList.remove("sidebar-hide");
          document.body.classList.add("sidebar-show");
        }
      });
    });

    return {
      isLoading,
      shouldShowSidebar,
      shouldShowPaddingZero,
      shouldShowHeader,
      shouldShowDiv,
      shouldShowFooter,
      isNotFound,
    };
  },
});


</script>

<style lang="scss" scoped>
.padding-0 {
  .container-fluid {
    padding: 0;
  }
}
</style>
